module.exports = __webpack_public_path__ + "static/media/52pic.b6d79b0c.jpg";